/**
 * `perk_data` (fallout1-ce src/game/perk.cc:34), transcribed mechanically.
 *
 * Generated by `scripts/gen-perk-table.mjs fo1`. Fallout 1's
 * `PerkDescription` is a narrower struct than Fallout 2's — no skilldex frm id,
 * no `paramMode`, and one skill requirement instead of two:
 *
 *     name, description, max_rank, min_level, stat, stat_modifier,
 *     required_skill, required_skill_level, required_stat_levels[7]
 *
 * The rows below are widened to `PerkRow` (the Fallout 2 shape, which is the
 * superset) so `rules.ts` can read one column layout for both games. The three
 * synthesised columns are exactly the values that make the Fallout 2 reader
 * behave like the Fallout 1 engine:
 *
 *   - `frmId` is `perk + 72`. That is not a convention we invented: fallout1-ce's
 *     own perk dialog computes it (`DrawCard2(name_sort_list[...].value + 72, ...)`,
 *     editor.cc:5275) and hands it to `art_id(OBJ_TYPE_SKILLDEX, ...)`.
 *   - `paramMode` is `PERK_PARAM_MODE_FIRST_ONLY`, so the second parameter is
 *     never consulted — which is correct, because Fallout 1 has no second one.
 *   - `param2`/`value2` are `-1`/`0`, the engine's own "no requirement".
 *
 * The GVAR bit (`0x4000000`) never appears in Fallout 1's table: every
 * `required_skill` there is a plain skill id or -1.
 *
 * Do not edit by hand. Re-run the generator.
 */

import type { PerkRow } from './perktable';

/**
 * `trait_data` (fallout1-ce trait.cc:31) — the `art_num` column, in Trait order.
 * A plain 55..70 run: Fallout 1 has no Sex Appeal, and index 13 is Night Person.
 */
export const TRAIT_FRM_IDS_FO1: readonly number[] = [
  55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70,
];

/**
 * `skill_data` (fallout1-ce skill.cc) — the `art_num` column, `28 + skill` for
 * all eighteen, the same run Fallout 2 uses.
 */
export const SKILL_FRM_IDS_FO1: readonly number[] = Array.from({ length: 18 }, (_, i) => 28 + i);

export const PERK_ROWS_FO1: readonly PerkRow[] = [
  [72, 1, 3, -1, 0, -1, 0, 0, -1, 0, 0, 5, 0, 0, 0, 0, 0],
  [73, 1, 6, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 6, 0],
  [74, 3, 3, 11, 2, -1, 0, 0, -1, 0, 6, 0, 0, 0, 0, 6, 0],
  [75, 3, 6, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 5, 0],
  [76, 2, 6, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 6, 6],
  [77, 1, 9, -1, 0, -1, 0, 0, -1, 0, 0, 6, 0, 0, 6, 7, 0],
  [78, 3, 3, 13, 2, -1, 0, 0, -1, 0, 0, 6, 0, 0, 0, 0, 0],
  [79, 3, 3, 14, 1, -1, 0, 0, -1, 0, 0, 0, 6, 0, 0, 0, 0],
  [80, 3, 6, 15, 5, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 6],
  [81, 3, 3, -1, 0, -1, 0, 0, -1, 0, 0, 6, 0, 0, 0, 0, 0],
  [82, 3, 3, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 6, 0, 0, 0],
  [83, 3, 6, 31, 15, -1, 0, 0, -1, 0, 0, 0, 6, 0, 4, 0, 0],
  [84, 3, 3, 24, 10, -1, 0, 0, -1, 0, 0, 0, 6, 0, 0, 0, 6],
  [85, 3, 3, 12, 50, -1, 0, 0, -1, 0, 6, 0, 6, 0, 0, 0, 0],
  [86, 2, 6, -1, 0, -1, 0, 0, -1, 0, 0, 7, 0, 0, 6, 0, 0],
  [87, 1, 6, -1, 0, 8, 50, 0, -1, 0, 0, 0, 0, 0, 0, 6, 0],
  [88, 3, 3, -1, 0, 17, 40, 0, -1, 0, 0, 0, 6, 0, 6, 0, 0],
  [89, 1, 9, -1, 0, 15, 60, 0, -1, 0, 0, 0, 0, 7, 0, 0, 0],
  [90, 3, 6, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 6, 0, 0],
  [91, 3, 3, -1, 0, 6, 40, 0, -1, 0, 0, 7, 0, 0, 5, 6, 0],
  [92, 1, 6, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 8],
  [93, 1, 9, 16, 20, -1, 0, 0, -1, 0, 0, 6, 0, 0, 0, 4, 6],
  [94, 1, 6, -1, 0, -1, 0, 0, -1, 0, 0, 7, 0, 0, 5, 0, 0],
  [95, 1, 18, -1, 0, 3, 80, 0, -1, 0, 8, 0, 0, 0, 0, 8, 0],
  [96, 1, 18, -1, 0, 0, 80, 0, -1, 0, 0, 8, 0, 0, 0, 8, 0],
  [97, 1, 18, -1, 0, 8, 80, 0, -1, 0, 0, 0, 0, 0, 0, 10, 0],
  [98, 3, 12, 8, 1, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 5, 0],
  [99, 1, 15, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 0],
  [100, 3, 12, -1, 0, -1, 0, 0, -1, 0, 0, 0, 4, 0, 0, 0, 0],
  [101, 2, 9, 9, 5, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 4, 0],
  [102, 1, 6, 32, 25, -1, 0, 0, -1, 0, 0, 0, 3, 0, 0, 0, 0],
  [103, 1, 12, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 0],
  [104, 1, 12, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 0],
  [105, 1, 12, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 0],
  [106, 1, 12, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 0],
  [107, 3, 6, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 0],
  [108, 1, 6, -1, 0, -1, 0, 0, -1, 0, 0, 4, 0, 0, 0, 0, 0],
  [109, 1, 9, -1, 0, 8, 80, 0, -1, 0, 0, 0, 0, 0, 0, 8, 0],
  [110, 1, 6, -1, 0, 8, 60, 0, -1, 0, 0, 0, 0, 0, 0, 0, 0],
  [111, 1, 12, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 10, 0, 0, 0],
  [112, 1, 9, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 8],
  [113, 1, 9, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 0],
  [114, 1, 9, -1, 0, -1, 0, 0, -1, 0, 0, 0, 5, 0, 0, 0, 0],
  [115, 2, 6, -1, 0, 17, 40, 0, -1, 0, 0, 0, 6, 0, 0, 0, 0],
  [116, 1, 9, -1, 0, 17, 25, 0, -1, 0, 0, 0, 0, 0, 5, 0, 0],
  [117, 1, 3, -1, 0, -1, 0, 0, -1, 0, 0, 8, 0, 0, 0, 0, 0],
  [118, 1, 6, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 7],
  [119, 3, 6, -1, 0, -1, 0, 0, -1, 0, 0, 6, 0, 0, 0, 0, 0],
  [120, 3, 3, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 5, 0],
  [121, 3, 3, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 4, 0, 0],
  [122, 3, 3, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 4, 0, 0],
  [123, 1, 12, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 0],
  [124, 1, 9, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 0],
  [125, -1, 1, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 0],
  [126, -1, 1, -1, 0, -1, 0, 0, -1, 0, -2, 0, -2, 0, 0, -3, 0],
  [127, -1, 1, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, -3, -2, 0],
  [128, -1, 1, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, -2, 0, 0],
  [129, -1, 1, 31, -20, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 0],
  [130, -1, 1, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 0],
  [131, -1, 1, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 0],
  [132, -1, 1, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 0],
  [133, -1, 1, -1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 0],
  [134, -1, 1, 31, 30, -1, 0, 0, -1, 0, 3, 0, 0, 0, 0, 0, 0],
  [135, -1, 1, 31, 20, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 0],
];
